import { formatErrorKeys } from '../../formatErrorKeys';
import { validateUsername } from '../validateUsername/validateUsername';

export const validateUsernameForProfileSetup = async (username: string) => {
    try {
        const response = await validateUsername(username);
        const formattedErrors = formatErrorKeys(response.data.errorKeys);

        return {
            errorKeys: formattedErrors,
        };
    } catch (_error) {
        return {
            errorKeys: {
                username: ['unspecified'],
            },
        } as const;
    }
};
